<template>
    <!-- 电池仓 -->
    <div class="batteryCom">
      <div
        class="margin-top-sm"
        v-for="(item, index) in 8"
        :key="index"
      >
      <div class="battery-color flex flex-direction justify-center" :class="{'battery-red':index==3}" @click="clickSingleBattery(item,index)">
        <div :class="{'select':index==curSingleIndex}">
          <div class="diamond"></div>
        </div>
        <div class="text-10 margin-left-15">
          NO.{{index+1}}
        </div>
      </div>
          
      </div>
    </div>
</template>
<script>
import { siteRight } from '@/api/singleSite/right';

export default {
  data() {
    return {
      batteryList:[],
      curSingleIndex:0,//当前选中电池下标,定义新的变量，防止修改父组件
    };
  },
  components: {},
  props: {
      selectBattery:{
        type:Number,
        default:0
    }
  },
  watch: {
    selectBattery(newValue, oldValue) {  
        console.log(newValue,'newValue') 
        this.curSingleIndex = newValue;
    } 
  },
  mounted() {
  },
  methods: {
    getData(data) {
      // this.getBatteryPackageInfo(data);
    },
    getBatteryPackageInfo(data={}){
        let _this = this;
        batteryBoxLeft
          .getBatteryPackageInfo(data)
          .then((res) => {
            if(!res) return;
            _this.batteryList = res;
          })
          .catch((err) => {
            console.log(err);
          });
      },
    // 点击单个电池
    clickSingleBattery(item,index){
      if(index!=this.curSingleIndex){
        this.curSingleIndex = index;
        this.$emit("changeParentIndex",index);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.batteryCom {
  margin-top:100px;
  display: grid;
  grid-template-columns: repeat(4, 150px);
  grid-template-rows: repeat(2, 46px);
  grid-row-gap: 60px;
  grid-column-gap: 30px;
  justify-content:center;
}
.battery-color {
  width: 153px;
  height: 64px;
  background: url('~@/assets/images/battery/battery_normal.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  .select{
    width: 168px;
    height:80px;
    left:-10px;
    border-radius: 6px;
    position: absolute;
    border: 2px solid rgba(79, 236, 242, 0.76);
    background: linear-gradient(180deg, rgba(13, 21, 25, 0) 0%, rgba(1, 177, 169, 0.46) 100%);
    .diamond{
      width:28px;
      height:33px;
      position: absolute;
      background: url('~@/assets/images/battery/battery_select.png') no-repeat;
      background-size:28px 33px;
      top:-50%;
      left:45%;
      // transform:translateX(-50%)；
    }
  }
}

.battery-red {
  background: url('~@/assets/images/battery/battery_alert.png') no-repeat;
  background-size: 100% 100%;
}
.batteryIcon {
  width: 12px;
  height: 16px;
  background: url('~@/assets/images/site/light-blue.png') no-repeat;
  background-size: 12px 16px;
}
.batteryNum {
  line-height: 10px;
}
</style>
